<template>
  <li class="mb-[5px] pl-[5px] text-lg font-light">
    <slot />
  </li>
</template>

<script setup lang="ts">
import type { Block } from '@contentful/rich-text-types'

const props = defineProps<{
  node: Block
}>()

// Hack to remove empty br hyperlink in list items
if (props.node.content && props.node.content.length > 0) {
  const paragraph =
    props.node.content[0]?.nodeType === 'paragraph'
      ? props.node.content[0]
      : null
  if (
    paragraph &&
    paragraph?.content?.length > 0 &&
    paragraph?.content[0]?.nodeType === 'text' &&
    paragraph?.content[0]?.value === '' &&
    paragraph?.content[1]?.nodeType === 'hyperlink'
  ) {
    paragraph.content.shift()
  }
}

defineOptions({
  name: 'CMSListItemNode',
})
</script>
